import { z } from 'zod';

import { getFormatMessage } from './validation-errors';

export const getStepOneValidationSchema = () => {
	const REQUIRED_MESSAGE = 'Обязательное поле';

	return z.object({
		id: z.union([z.number().optional(), z.null()]),
		createdBlankAt: z.string().date(),
		firstName: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		middleName: z.string().trim().optional(),
		lastName: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		birthday: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		gender: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		establishment: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		program: z.string().trim().optional(),
		spokesman: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		violations: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		diagnosis: z.string().optional().or(z.literal('')),
		additionalInformation: z.string().optional().or(z.literal('')),
		customerRequest: z.string().trim().nonempty(REQUIRED_MESSAGE).min(1),
		nextInterview: z.union([z.string().date(), z.literal(''), z.null()]).optional(),
		email: z.string().email(getFormatMessage()).trim().nonempty(REQUIRED_MESSAGE).min(1),
		optionalEmail: z.preprocess(
			(val) => {
				if (val === '' || val === null || val === undefined) return undefined;
				return val;
			},
			z.string().email(getFormatMessage()).optional()
		),
		stepType: z.string().optional(),
	});
};

export type StepOneValidationSchema = z.infer<ReturnType<typeof getStepOneValidationSchema>>;
